module.exports = __webpack_public_path__ + "img/23.585b2193.webp";